import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const jobDataClassName = DataClassName.JOB
const jobEndpoint = PisaDataClassEndpoint.JOB

export function pisaJobDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(jobDataClassName, {
    title: jobDataClassName,
    restApi: createPisaRestApiConfig(jobEndpoint),
    attributes,
  })
}
